package models

import kotlinx.serialization.Serializable

@Serializable
data class OrgProductModelForWeb(
    val id: Int,
    val productName: String,
    val category: String,
    val fo: String,
    val note: String
)